import {types, getType} from 'mobx-state-tree';

export const AppFeedbackIntent = types.union(
  types.literal('success'),
  types.literal('error'),
  types.literal('info'),
  types.literal('warning')
);

export const AppNotificationModel = types.model({
  uid: types.string,
  title: types.string,
  body: types.string,
  intent: types.maybe(AppFeedbackIntent),
  showCloseButton: types.optional(types.boolean, true),
  autoClose: types.optional(types.boolean, true),
  duration: types.optional(types.number, 4500)
});

export type AppNotification = typeof AppNotificationModel.Type;

export const AppMessageModel = types.model({
  uid: types.string,
  message: types.string,
  intent: types.maybe(AppFeedbackIntent),
  duration: types.optional(types.number, 2500)
});

export type AppMessage = typeof AppMessageModel.Type;

export type AppFeedbackActions = {
  add: (entry: AppNotification | AppMessage) => string;
  remove: (entry: AppNotification | AppMessage) => void;
};

const AppFeedbackModel = types
  .model({
    entries: types.array(types.union(AppNotificationModel, AppMessageModel))
  })
  .views(self => ({
    get notifications() {
      return self.entries.filter(e => getType(e) === AppNotificationModel);
    },
    get messages() {
      return self.entries.filter(e => getType(e) === AppMessageModel);
    }
  }))
  .actions<AppFeedbackActions>(self => ({
    add: function(entry: AppNotification | AppMessage) {
      self.entries.push(entry);
      return entry.uid;
    },

    remove: function(entry: AppNotification | AppMessage) {
      const index = self.entries.findIndex(x => x.uid === entry.uid);

      if (index <= -1) {
        throw new Error('AppFeedbackModel Error: Entry not found.');
      }
      self.entries.splice(index, 1);
    }
  }));

export type AppFeedback = typeof AppFeedbackModel.Type;

export default AppFeedbackModel;



// WEBPACK FOOTER //
// ./src/models/appFeedbackModel.ts